import { Language } from '../context/LanguageContext';
import { getLocalizedJewelleryCollectionItems, JewelleryCollectionItemView } from '../utils/jewelleryCollectionUtils';

export interface SnakeTranslations {
    mainTitle: string;
    mainSubtitle: string;
    symbolTitle: string;
    symbolSubtitle: string;
    symbolDescription: string;
    paradiseTitle: string;
    paradiseSubtitle: string;
    paradiseDescription: string;
    moreTitle: string;
    moreSubtitle: string;
    moreDescription: string;
    collectionItems: Array<{
        id: string;
        name: string;
        description: string;
        image: string;
    }>;
}

type SnakeTemplateBase = Omit<SnakeTranslations, 'collectionItems'>;

const snakeTemplateBaseTranslations: Partial<Record<Language, SnakeTemplateBase>> = {
    en: {
        mainTitle: "A SNAKE'S",
        mainSubtitle: "WISDOM",
        symbolTitle: "SNAKE - THE SYMBOL",
        symbolSubtitle: "of occult knowledge",
        symbolDescription: "The snake is appearing in all ancient religions or mythologies at the highest level. In ancient Egypt it appears at the top of the golden masks of the Pharaohs and symbolises Divinity. In the Indian Yoga-Disciplines it is Kundalini, the force that rises through the Chakras to the highest, where Unity with the Divine is established. Kukulkan, the feathered snake, headed a pantheon of deities both of the Mayas as well as other people in Middle-America.",
        paradiseTitle: "ANIMAL OF",
        paradiseSubtitle: "PARADISE",
        paradiseDescription: "In Christianity the snake appears in the Genesis of the old Bible. It offers an apple to Adam & Eve, and tells them, that if they eat from the apple, they will be like God. God then was so annoyed about this, that he drove Adam and Eve out of Paradise. The snake is more than just an animal. In all ancient religions and mythologies, the snake is a symbol of Wisdom, Power and Knowledge in the metaphysical worlds.",
        moreTitle: "MORE THAN",
        moreSubtitle: "JUST AN ANIMAL",
        moreDescription: "In all ancient religions and mythologies, the snake is a symbol of Wisdom, Power and Knowledge in the metaphysical worlds."
    },
    de: {
        mainTitle: "DIE WEISHEIT",
        mainSubtitle: "EINER SCHLANGE",
        symbolTitle: "SCHLANGE - DAS SYMBOL",
        symbolSubtitle: "DES OKKULTEN WISSENS",
        symbolDescription: "Die Schlange taucht in allen alten Religionen oder Mythologien auf höchster Ebene auf. Im alten Ägypten erscheint sie an der Spitze der goldenen Masken der Pharaonen und symbolisiert die Göttlichkeit. In den indischen Yoga-Disziplinen ist sie Kundalini, die Kraft, die durch die Chakras bis zum höchsten aufsteigt, wo die Einheit mit dem Göttlichen hergestellt wird. Kukulkan, die gefiederte Schlange, stand an der Spitze eines Pantheons von Gottheiten sowohl der Mayas als auch von Nicht-Maya-Volksstämmen in Mittel-Amerika.",
        paradiseTitle: "Die Verführung",
        paradiseSubtitle: "im Paradies",
        paradiseDescription: "Im Christentum taucht die Schlange in der Genesis des Alten Testaments auf. Sie bietet Adam und Eva einen Apfel an und sagt ihnen, dass sie, wenn sie von dem Apfel essen, wie Gott sein werden. Gott war darüber so verärgert, dass er Adam und Eva aus dem Paradies vertrieb. Die Schlange ist mehr als nur ein gewöhnliches Tier. Sie ist ein Symbol für den Türöffner zu den höheren Bewusstseinsebenen.",
        moreTitle: "MEHR ALS",
        moreSubtitle: "NUR EIN TIER",
        moreDescription: "In allen alten Religionen und Mythologien ist die Schlange ein Symbol für Weisheit, Macht und Wissen in den metaphysischen Welten."
    },
    fr: {
        mainTitle: "LA SAGESSE",
        mainSubtitle: "D'UN SERPENT",
        symbolTitle: "SERPENT - LE SYMBOLE",
        symbolSubtitle: "de la connaissance occulte",
        symbolDescription: "Le serpent apparaît dans toutes les religions ou mythologies anciennes au plus haut niveau. Dans l'Égypte ancienne, il apparaît au sommet des masques d'or des pharaons et symbolise la Divinité. Dans les disciplines du yoga indien, c'est Kundalini, la force qui s'élève à travers les Chakras jusqu'au plus haut, où l'Unité avec le Divin est établie. Kukulkan, le serpent à plumes, dirigeait un panthéon de divinités à la fois des Mayas et des non-Mayas en Amérique centrale.",
        paradiseTitle: "ANIMAL DU",
        paradiseSubtitle: "PARADIS",
        paradiseDescription: "Dans le christianisme, le serpent apparaît dans la Genèse de l'ancienne Bible. Il offre une pomme à Adam et Ève et leur dit que s'ils mangent de la pomme, ils seront comme Dieu. Dieu était alors si contrarié par cela qu'il a chassé Adam et Ève du Paradis. Le serpent est plus qu'un simple animal. Dans toutes les religions et mythologies anciennes, le serpent est un symbole de Sagesse, de Pouvoir et de Connaissance dans les mondes métaphysiques.",
        moreTitle: "PLUS QU'UN",
        moreSubtitle: "SIMPLE ANIMAL",
        moreDescription: "Dans toutes les religions et mythologies anciennes, le serpent est un symbole de Sagesse, de Pouvoir et de Connaissance dans les mondes métaphysiques."
    },
    zh: {
        mainTitle: "蛇的",
        mainSubtitle: "智慧",
        symbolTitle: "蛇--神秘知識的象徵",
        symbolSubtitle: "神秘知識的象徵",
        symbolDescription: "蛇在所有古代宗教或神話中都以最高級別出現。在古埃及，它出現在法老金面具的頂部並象徵著神性。在印度瑜珈學科中，它是昆達里尼，一種透過脈輪上升到最高點的力量，在那裏與神的合一得以建立。庫庫爾坎，即羽蛇，領導著中美洲瑪雅及非瑪雅來源的眾神體系。",
        paradiseTitle: "伊甸園",
        paradiseSubtitle: "動物",
        paradiseDescription: "在基督教中，蛇出現在舊聖經的《創世紀》中。它為亞當及夏娃提供了一個蘋果，並告訴他們，如果他們吃了這個蘋果，他們就會像上帝一樣。上帝對此非常惱火，把亞當和夏娃逐出伊甸園。蛇不僅是動物。在所有古代宗教和神話中，蛇是形而上學世界中智慧、力量和知識的象徵。",
        moreTitle: "不僅是",
        moreSubtitle: "動物",
        moreDescription: "在所有古代宗教和神話中，蛇是形而上學世界中智慧、力量和知識的象徵。"
    }
};

export function getSnakeTranslations(language: Language): SnakeTranslations {
    const base = snakeTemplateBaseTranslations[language] || snakeTemplateBaseTranslations.en!;
    const collectionItems = getLocalizedJewelleryCollectionItems('snake', language).map((item: JewelleryCollectionItemView) => ({
        id: item.id,
        name: item.name,
        description: item.description,
        image: item.image
    }));

    return {
        ...base,
        collectionItems
    };
}
